var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventTeam(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.8h-.2a2.9 2.9 0 1 1 .2 0ZM20.8 14.7c-1.1.8-2.7 1-4.2.8a6.5 6.5 0 0 0 0-5.4c1.5-.2 3 0 4.2.8 1.6 1 1.6 2.8 0 3.8ZM6.4 7.8h.3c1.5 0 2.7-1.3 2.7-3a2.9 2.9 0 1 0-3 3ZM6.6 12.9c0 1 .2 1.8.5 2.7-1.4.1-2.8-.2-4-.9-1.5-1-1.5-2.7 0-3.8 1.2-.7 2.7-1 4-.8-.3.8-.5 1.7-.5 2.8ZM12.1 15.9H12a3.4 3.4 0 0 1-3.4-3.5 3.4 3.4 0 0 1 7 0c0 1.9-1.5 3.4-3.4 3.5ZM8.9 18c-1.5 1-1.5 2.6 0 3.6a6.1 6.1 0 0 0 6.2 0c1.5-1 1.5-2.7 0-3.7A6.1 6.1 0 0 0 9 18Z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventTeam);
export default __webpack_public_path__ + "static/media/eventTeam.669f5919b1d212e790536077855ac12e.svg";
export { ForwardRef as ReactComponent };